import { TableColumn } from "@models/components/tableColumn";
import { ClientDetailsService } from "@services/clients/clients.details/clientdetails.service";


export class ClientDetailsComplianceController {
    public client: any;
    public compliances: any[] = [];
    public selectAll: boolean = false;
    public isLoadingCompliance: boolean = true;
    public isLoading: boolean = false;
    
    // Reusable table properties for compliance
    public complianceColumns: TableColumn[] = [
        { key: 'assetManagementMandate', label: 'Asset Management Mandate', type: 'text' },
        { key: 'amendedDate', label: 'Amended Date', type: 'date' },
        { key: 'comment', label: 'Comment', type: 'text' }
    ];

    /** @ngInject */
    constructor(
        private $mdDialog: angular.material.IDialogService,
        private $rootScope: angular.IRootScopeService,
        private clientDetailsService: ClientDetailsService
    ) {}

    public $onInit(): void {
        this.isLoading = !this.client;
        if (this.client && this.client.id) {
            this.loadComplianceData();
        }
    }

    public $onChanges(changes: any): void {
        if (changes.client && changes.client.currentValue && changes.client.currentValue.id) {
            this.isLoading = false;
            this.loadComplianceData();
        }
    }

    public isIndividual(): boolean {
        return this.clientDetailsService.isIndividual(this.client);
    }

    public isInstitution(): boolean {
        return this.clientDetailsService.isInstitution(this.client);
    }

    private loadComplianceData(): void {
        this.isLoadingCompliance = true;
        
        // Mock data for demonstration - replace with actual API call
        setTimeout(() => {
            this.compliances = [
                {
                    assetManagementMandate: '5/26/2021',
                    amendedDate: new Date('2023-06-20'),
                    comment: 'Doc 119 daté du 20.06.2023 pour inclure le pf EDR',
                    selected: false
                }
            ];
            this.isLoadingCompliance = false;
        }, 1000);
    }

    public toggleSelectAll(selected: boolean): void {
        this.selectAll = selected;
        this.compliances.forEach(compliance => {
            compliance.selected = selected;
        });
    }

    public updateSelection(item: any, selected: boolean): void {
        item.selected = selected;
        const selectedCount = this.compliances.filter(compliance => compliance.selected).length;
        this.selectAll = selectedCount === this.compliances.length;
    }

    public newCompliance(): void {
        const tempScope = this.$rootScope.$new(true) as any;
        tempScope.client = this.client;

        this.$mdDialog
            .show({
                template: '<md-dialog flex="70"><add-compliance-modal client="client"></add-compliance-modal></md-dialog>',
                scope: tempScope,
                clickOutsideToClose: true,
                escapeToClose: true
            })
            .then((result) => {
                if (result) {
                    // TODO: Add the new compliance to the list when backend is linked
                    console.log('New compliance added:', result);
                    // this.compliances.push(result);
                    // this.refreshCompliance();
                }
            });
    }
}

export const ClientDetailsComplianceComponent: angular.IComponentOptions = {
    template: require('./clientdetails.compliance.html'),
    controller: ClientDetailsComplianceController,
    controllerAs: '$ctrl',
    bindings: {
        client: '<'
    }
};



// WEBPACK FOOTER //
// ./src/app/clients/clients.details/compliance/clientdetails.compliance.ts